import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls to top on route change, but preserves scroll position when using browser back/forward.
 * A link with #id (for example /getting-around#high1) then lands on that element.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Check if this is a navigation (not back/forward)
    // Browser handles scroll restoration for back/forward automatically when using 'manual'
    if (window.history.scrollRestoration) {
      window.history.scrollRestoration = 'manual';
    }
    
    // Scroll to top on pathname change
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    if (!hash) return;
    // The page is lazy, so the element may take a moment to exist.
    const id = decodeURIComponent(hash.slice(1));
    let tries = 0;
    const timer = window.setInterval(() => {
      const target = document.getElementById(id);
      if (target) target.scrollIntoView();
      if (target || ++tries >= 20) window.clearInterval(timer);
    }, 100);
    return () => window.clearInterval(timer);
  }, [pathname, hash]);

  return null;
}
